import styled from 'styled-components';
import { Text } from 'core/ui/atoms';

export const HeaderText = styled(Text)`
  font-size: 22px;
  font-weight: 400;
  line-height: 15px;
  text-align: center;
  color: ${(p) => p.theme.colors.primaryV2};
  font-family: ${({ theme }) => theme.typography.familyLarken};
`;

export const SectionHeaderText = styled(Text)`
  font-size: 18px;
  font-weight: 400;
  line-height: 20px;
  text-align: center;
  color: ${(p) => p.theme.colors.primaryV2};
  font-family: ${({ theme }) => theme.typography.familyLarken};
  margin-bottom: 12px;
`;
